import script from "./ViewableTasks.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewableTasks.vue?vue&type=script&setup=true&lang=js"

import "./ViewableTasks.vue?vue&type=style&index=0&id=1cb9d67e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cb9d67e"]])

export default __exports__